import AppcastDisclaimer from './appcast-disclaimer'
import GenericDisclaimer from './generic-disclaimer'
import ReedDisclaimer from './reed-disclaimer'

export { AppcastDisclaimer, GenericDisclaimer, ReedDisclaimer }
